import { Instance } from 'mobx-state-tree';
import { ErrorDetailsDtoModelBase } from './ErrorDetailsDtoModel.base';

/* The TypeScript type of an instance of ErrorDetailsDtoModel */
export interface ErrorDetailsDtoModelType extends Instance<typeof ErrorDetailsDtoModel.Type> {}

/* A graphql query fragment builders for ErrorDetailsDtoModel */
export { selectFromErrorDetailsDto, errorDetailsDtoModelPrimitives, ErrorDetailsDtoModelSelector } from './ErrorDetailsDtoModel.base';

/**
 * ErrorDetailsDtoModel
 */
export const ErrorDetailsDtoModel = ErrorDetailsDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
